import { Injectable } from "@angular/core";
import { Action } from "@ngrx/store";
import { ActionWithPayload, SYNC_SUFFIX } from "@obg/ngrx-utils";

import { AppError } from "../app-error/app-error.model";

import { Jurisdiction } from "./jurisdiction.model";

const ACTION_PREFIX = "[Jurisdiction]";
export const JURISDICTION_ACTION_TYPE = {
	setByAppContext: `${ACTION_PREFIX} Set by App Context ${SYNC_SUFFIX}`,
	set: `${ACTION_PREFIX} Set ${SYNC_SUFFIX}`,
	setByCountryCode: `${ACTION_PREFIX} Set by Country Code ${SYNC_SUFFIX}`,
	get: `${ACTION_PREFIX} Get`,
	getSuccess: `${ACTION_PREFIX} Get Success`,
	getFail: `${ACTION_PREFIX} Get Fail`,
};

@Injectable({
	providedIn: "root",
})
export class JurisdictionAction {
	setByAppContext(): Action {
		return {
			type: JURISDICTION_ACTION_TYPE.setByAppContext,
		};
	}

	set(payload: Jurisdiction): ActionWithPayload {
		return {
			type: JURISDICTION_ACTION_TYPE.set,
			payload,
		};
	}

	setByCountryCode(countryCode: string): ActionWithPayload {
		return {
			type: JURISDICTION_ACTION_TYPE.setByCountryCode,
			payload: countryCode,
		};
	}

	get(): Action {
		return {
			type: JURISDICTION_ACTION_TYPE.get,
		};
	}

	getSuccess(jurisdiction: Jurisdiction): ActionWithPayload {
		return {
			type: JURISDICTION_ACTION_TYPE.getSuccess,
			payload: jurisdiction,
		};
	}

	getFail(response: AppError): ActionWithPayload {
		return {
			type: JURISDICTION_ACTION_TYPE.getFail,
			payload: response,
		};
	}
}
